export default function FeaturedContractors() {
  const contractors = [
    {
      name: 'Desert Sun Roofing',
      specialty: 'Roofing Contractor',
      rating: 4.9,
      reviews: 287,
      image: 'https://public.readdy.ai/ai/img_res/404cb3e1b6918e35aa7a80f904ecda3a.jpg',
      years: '15+ years',
      badge: 'Top Rated'
    },
    {
      name: 'Cool Comfort HVAC',
      specialty: 'HVAC Services',
      rating: 4.8,
      reviews: 342,
      image: 'https://readdy.ai/api/search-image?query=Professional%20HVAC%20technician%20in%20uniform%20standing%20next%20to%20service%20van%20in%20El%20Paso%2C%20friendly%20expert%20with%20tools%20and%20equipment%2C%20modern%20residential%20neighborhood%20background%2C%20bright%20professional%20photography%20showing%20trustworthy%20service%20provider%2C%20clean%20company%20vehicle%20with%20branding&width=400&height=300&seq=contractor-hvac-014&orientation=landscape',
      years: '12+ years',
      badge: 'Certified Pro'
    },
    {
      name: 'Elite Home Remodeling',
      specialty: 'Kitchen &amp; Bath Remodeling',
      rating: 5.0,
      reviews: 198,
      image: 'https://readdy.ai/api/search-image?query=Professional%20home%20remodeling%20contractor%20team%20in%20El%20Paso%2C%20skilled%20craftsmen%20in%20work%20attire%20with%20tools%2C%20standing%20in%20beautiful%20renovated%20kitchen%2C%20southwestern%20contemporary%20interior%20design%2C%20bright%20natural%20lighting%20showing%20quality%20workmanship%20and%20professional%20team&width=400&height=300&seq=contractor-remodel-015&orientation=landscape',
      years: '20+ years',
      badge: 'Award Winner'
    },
    {
      name: 'Franklin Mountain Landscaping',
      specialty: 'Landscape Design &amp; Maintenance',
      rating: 4.9,
      reviews: 256,
      image: 'https://readdy.ai/api/search-image?query=Professional%20landscaping%20crew%20in%20El%20Paso%20working%20on%20beautiful%20desert%20garden%2C%20team%20of%20landscapers%20with%20equipment%20creating%20xeriscaping%20design%2C%20native%20plants%20and%20decorative%20rocks%2C%20mountain%20views%20in%20background%2C%20bright%20sunny%20day%20showing%20quality%20landscape%20work&width=400&height=300&seq=contractor-landscape-016&orientation=landscape',
      years: '10+ years',
      badge: 'Eco Certified'
    }
  ];

  return (
    <section id="contractors" className="py-20 px-6 bg-gray-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Featured Local Contractors
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Meet some of El Paso's most trusted home improvement professionals. These featured contractors have demonstrated exceptional quality, reliability, and customer service. Each has been thoroughly vetted and maintains the highest standards in their respective trades.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 mb-12">
          {contractors.map((contractor, index) => (
            <div key={index} className="bg-white rounded-xl overflow-hidden border border-gray-100 hover:border-teal-500 hover:shadow-xl transition-all duration-300">
              <div className="relative h-48 overflow-hidden">
                <img 
                  src={contractor.image} 
                  alt={contractor.name}
                  className="w-full h-full object-cover object-top"
                />
                <div className="absolute top-3 right-3">
                  <span className="px-3 py-1 bg-teal-600 text-white text-xs font-bold rounded-full">
                    {contractor.badge}
                  </span>
                </div>
              </div>
              <div className="p-5">
                <h3 className="text-lg font-bold text-gray-900 mb-1">{contractor.name}</h3>
                <p className="text-sm text-gray-600 mb-3">{contractor.specialty}</p>
                
                <div className="flex items-center gap-2 mb-3">
                  <div className="flex items-center gap-1">
                    <i className="ri-star-fill text-yellow-400 text-sm"></i>
                    <span className="text-sm font-semibold text-gray-900">{contractor.rating}</span>
                  </div>
                  <span className="text-xs text-gray-500">({contractor.reviews} reviews)</span>
                </div>

                <div className="flex items-center justify-between pt-3 border-t border-gray-100">
                  <span className="text-xs text-gray-600">{contractor.years} experience</span>
                  <a href="#contact" className="text-sm font-medium text-teal-600 hover:text-teal-700 whitespace-nowrap">
                    View Profile →
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="bg-gradient-to-r from-teal-600 to-teal-700 rounded-xl p-8 md:p-12 text-center text-white">
          <h3 className="text-3xl font-bold mb-4">
            Your Company Could Be Featured Here
          </h3>
          <p className="text-lg text-white/90 mb-8 max-w-2xl mx-auto">
            Reach thousands of El Paso homeowners actively searching for contractors. Our featured listings receive 10x more visibility and generate qualified leads for your business. Join our network of trusted professionals today.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a href="#list-service" className="px-8 py-4 bg-white text-teal-600 font-semibold rounded-lg hover:bg-gray-50 transition-colors whitespace-nowrap">
              List Your Service
            </a>
            <a href="#learn-more" className="px-8 py-4 bg-teal-500 text-white font-semibold rounded-lg hover:bg-teal-400 transition-colors whitespace-nowrap">
              Learn More
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
